import {Component, input, output} from '@angular/core';
import {Button} from 'primeng/button';
import {CreateTaStep} from '../../../../util/app.types';
import {NgClass} from '@angular/common';

@Component({
  selector: 'timeline-step',
  template: `
    <p-button [severity]="currentlySelected() ? 'primary' : 'secondary'" (click)="stepClicked.emit()" [text]="true" [disabled]="!step()?.enabled">
      <div class="flex items-center gap-2">
        <div class="border-2 rounded-full w-10 h-10 flex items-center justify-center"
             [ngClass]="currentlySelected() ? 'border-primary' : 'border-surface-200'">
            <div class="shadow rounded-full w-9 h-9 flex items-center justify-center text-lg font-medium"
                 [ngClass]="currentlySelected() ? 'text-primary' : 'text-secondary-800'">
              @if (step()?.valid) {
                <i class="fa-check fa-sharp fa-solid " [ngClass]="currentlySelected() ? 'text-primary' : 'text-surface-400'"></i>
              } @else {
                {{ (index() ?? 0) + 1 }}
              }
            </div>
        </div>
        <span class="text-sm font-medium" [ngClass]="currentlySelected() ? 'text-primary' : 'text-secondary-800'">
          {{ step()?.title }}
        </span>
      </div>
    </p-button>
  `,
  imports: [
    Button,
    NgClass
  ],
  styles: []
})
export class TimelineStepComponent {
  step = input<CreateTaStep>();
  index = input<number>();
  currentlySelected = input<boolean>();
  stepClicked = output();
}
